<div class="gt-no-modules-background">
  <div class="gt-no-modules-container">
    <div class="logo-container">
      <img class="logo" src="assets/img/logo-60.png" width="60" height="60" alt="Logo">
    </div>
    <div class="message-container">
      <h4><i class="fa fa-ban"></i>&nbsp; No Modules</h4>
      <p>You don't have Modules assigned, Please contact to support center</p>
    </div>
  </div>
</div>
